module.exports = __webpack_public_path__ + "img/theme-edu_logo.31ec94af.png";